
































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { StudentPhotoVModel } from '@/models/studentPhoto/studentPhoto'
import { ElForm } from 'element-ui/types/form'
import { editstatus } from '@/api/studentPhoto/studentPhoto'
import { notify } from '@/utils/notification'

@Component
export default class EditStatus extends Vue {
    @Prop({ type: Object, required: true }) form!: StudentPhotoVModel

    status: any[] = [
        { label: '未采集', value: 0 },
        { label: '审核中', value: 1 },
        { label: '比对成功', value: 2 },
        { label: '比对失败', value: 3 },
        { label: '留存', value: 4 },
        { label: '放弃入学', value: 5 },
        { label: '特殊', value: 6 }
    ]



    async handleEditer() {
        try {
            await editstatus(this.form.id, this.form.ok)
            notify('设置成功')
            this.$emit('SaveSuccess')
        } catch (e) {
            notify('编辑设置失败', e)
        } finally {
            this.form = {
                id: '',
                xm: '',
                account: '',
                ksh: '',
                zkzh: '',
                xuehao: '',
                ok: 0,
                xb: '',
                csny: '',
                sfzh: '',
                zymc: '',
                csmbh: '',
                xymc: '',
            }
        }
    }

    @Emit('clickReturn')
    onReturn($event: any) {
        this.form = {
            id: '',
            xm: '',
            account: '',
            ksh: '',
            zkzh: '',
            xuehao: '',
            ok: 0,
            xb: '',
            csny: '',
            sfzh: '',
            zymc: '',
            csmbh: '',
            xymc: '',
        }
        return $event
    }
}
